import { FC } from 'react';
import { DesktopLayoutImageProps } from './desktopLayoutImage.type';
import Loginlayout from '../../assets/login_layout.jpg';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'desktop-layout-image';

const DesktopLayoutImage: FC<DesktopLayoutImageProps> = () => {
  return (
    <div
      className="hidden md:flex w-3/5 items-center justify-center m-6"
      {...getIdAttributes(idPrefix, 'image-container')}
    >
      <img
        src={Loginlayout}
        alt="Login Layout"
        className="w-full h-full object-cover rounded-2xl"
        {...getIdAttributes(idPrefix, 'loginLayout')}
      />
    </div>
  );
};

export default DesktopLayoutImage;
